import React from "react"
import styled, { css } from "styled-components"
import { Link } from "gatsby"
import colors from "@constants/colors"
import { smallcapsBold13Styles, body14Styles } from "@constants/typography"
import { getExploreEntryTypeURL } from "@utils/urls"

const Container = styled(Link)<{
  width: string | undefined
}>`
  ${({ width }) => css`
    width: ${width || "50%"};
    min-width: 200px;
    padding: 0 24px;
  `}
`

const Name = styled.div`
  ${smallcapsBold13Styles}
  margin-bottom: 20px;
`

const Description = styled.div`
  ${body14Styles}
  line-height: 20px;
  color: ${colors.mediumGray};
`

interface EntryTypeProps {
  link: string
  name: string
  description: string
  width: string | undefined
}

const EntryType: React.FC<EntryTypeProps> = ({
  link,
  name,
  description,
  width,
}) => {
  return (
    <Container to={getExploreEntryTypeURL(link)} width={width}>
      <Name>{name}</Name>
      <Description>{description}</Description>
    </Container>
  )
}

export default EntryType
